module.exports = __webpack_public_path__ + "img/ringcase@2x.9415fa0.webp";